import { filter, map, pipe, sort, unique } from '@vestigas/utils';

import { type DeliveryNoteAdmin } from '../types';

/**
 * Returns the order references for a given delivery note and type (buyer or seller).
 * @param assetBody - The body of the delivery note to get the order references for.
 * @param type - The type of order reference to get (buyer or seller).
 * @returns The list of unique sorted order references for the given delivery note and type.
 */
export const getOrderReferences = (
  assetBody: DeliveryNoteAdmin,
  type: 'buyerOrder' | 'sellerOrder',
) => {
  if (!assetBody?.transaction?.logisticsPackage?.[0]?.lineItem?.length) {
    return [];
  }

  return pipe(
    assetBody.transaction.logisticsPackage[0].lineItem,
    map((item) => item?.agreement?.[type]?.trim()),
    unique,
    filter(Boolean),
    sort((a, b) => a.localeCompare(b)),
  );
};
